import { onTurboPageLoad } from "../turboHelper";
import { attachCancelButtonConfirmation } from "../helpers";
import * as Turbo from "@hotwired/turbo";
import { getModel } from "../modelHelper";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";

onTurboPageLoad("Pois/AddTranslation", () => {
    const model = getModel<IModel>();

    const form = $("#createNewTranslationForm");

    formSubmitWithWaitForJobCompletion(
        form,
        $("#submit"),
        model.getJobUrl,
        () => {

            var formData = new FormData(form[0] as HTMLFormElement);
            var selectedLanguage = formData.get(model.languageSelectName);

            var editPoiUrl = model.editPoiUrl.replace("$language", `${selectedLanguage}`);

            Turbo.clearCache();
            Turbo.visit(editPoiUrl);
        },
        "Really create a new Place translation?"
    );

    selectize($("select"), {
        score: getScoreFunctionPreservingOrderInSearch
    });

    attachCancelButtonConfirmation();
});

interface IModel {
    getJobUrl: string;
    editPoiUrl: string;
    languageSelectName: string;
}
